import { combineReducers } from '@reduxjs/toolkit';
import apiKeys from './slice';

export default combineReducers({
    apiKeys
});